import React from 'react';
import { Link } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import { IncidentsMap } from '../components/incidents-map/IncidentsMap';

const Incidents = () => (
    <Layout
        title="Incidents"
        intro="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tempus posuere risus sed dolor mauris ultrices ut. Viverra sed aliquam malesuada suscipit eget non massa viverra  aliquam malesuada suscipit eget non massa viverr. Tincidunt nam mattis purus, egestas aenean."
        mapView
    >
        <SEO title="Incidents" />
        <IncidentsMap />

        {/* <Link to="/">Go back to the homepage</Link> */}
    </Layout>
);

export default Incidents;
